import { Component, OnInit, TemplateRef, ViewChildren, ElementRef, Renderer2 } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';

import { ToastrService } from "ngx-toastr";
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SiteService } from 'src/app/services/site.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { of, switchMap } from 'rxjs';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { slideTrigger } from 'src/app/events-calendar/common/animation/triggers/slideTrigger';
import { animate, state, style, transition, trigger } from '@angular/animations';
@Component({
  selector: 'app-roles-manager',
  templateUrl: './roles-manager.component.html',
  styleUrls: ['./roles-manager.component.css'],
  animations: [
    slideTrigger,
    trigger('zipper', [
      state('collapsed', style({
        height: '0px',
        overflow: 'hidden',
        paddingTop: '0px',
        paddingBottom: '0px'
      })),
      state('expanded', style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*'
      })),
      transition('collapsed <=> expanded', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class RolesManagerComponent implements OnInit {
  @ViewChildren('inputFocus') inputFocus: any;


  searchText = ""
  filterText = ""
  modalRef: BsModalRef;
  temp: any = {};
  levels: any[] = [];
  catId: any;
  clickButton = false
  filterdOptions: any[] = [];
  getUsedSiteCulturesSubscription: Subscription;



  form: FormGroup = new FormGroup({
    id: new FormControl(0),
    Status: new FormControl(1),
    parentId: new FormControl(0),
    displayOrder: new FormControl(0),
    CategoryTypeId: new FormControl(6),
    IncludeInMenu: new FormControl(false),
    CategoryDetails: new FormArray([])
  });
  siteCultures: any;



  constructor(private modalService: BsModalService, public siteService: SiteService, private route: ActivatedRoute,


    private snotifyService: ToastrService, private httpClient: HttpClient, private renderer: Renderer2) { }


  ngOnInit() {
    this.getUserCutler();
    this.loadScript();
    this.getAllLevels();

  }
  activeTab = 0;
  activeInnerTab = 1;

  updateActiveTab(v) {
    this.activeTab = this.activeTab == v ? null : v;
    this.activeInnerTab = 1;
  }


  getData(event) {
    return this.siteCultures.find(x => x.id == event.value.cultureId).name;
  }

  reference: any;
  getUserCutler() {

    this.getUsedSiteCulturesSubscription = this.siteService.getUsedSiteCultures(2).pipe(
      switchMap((res) => {
        this.siteCultures = res;
        return this.route.paramMap;
      })
    )
      .subscribe(
        (res: any) => {


          this.initializeCulturesForm();
        }
      )

  }



  resetForm() {
    this.form.reset();
    this.form.get('id').setValue(0);
    this.form.get('Status').setValue(1);
    this.form.get('parentId').setValue(0);
    this.form.get('displayOrder').setValue(0);
    this.form.get('CategoryTypeId').setValue(6);
    this.form.get('IncludeInMenu').setValue(false);


    this._CategoryDetails.clear();
    this.getUserCutler();
  }

  initializeCulturesForm() {
    const formArray = this._CategoryDetails;
    if (this.siteCultures && this.siteCultures.length) {
      for (let i = 0; i < this.siteCultures.length; i++) {
        const cultureId = this.siteCultures[i].id;
        const cultureCode = this.siteCultures[i].name;
        const cultureInformation = new FormGroup({
          id: new FormControl(0),
          categoryTemplateId: new FormControl(0),
          slugInfoId: new FormControl(0),
          description: new FormControl(""),
          metaDescription: new FormControl(""),
          metaTitle: new FormControl(""),
          name: new FormControl("", [Validators.required]),
          slug: new FormControl("", [Validators.required]),
          cultureId: new FormControl(cultureId),
          cultureCode: new FormControl(cultureCode),
        })
        formArray.push(cultureInformation);


      }
    }

  }




  getAllLevels() {
    this.temp = {};
    this.httpClient.get('/RolesManagement/GetOptionsLevelsOfUserRole').subscribe((res: any) => {
      this.levels = res
      this.filterdOptions = this.levels
    });
  }

  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }


  applyFilter(val): void {

  }

  decline(): void {
    this.modalRef.hide();
    this.resetForm();
    // this.getUserCutler();
  }

  openModal(template: TemplateRef<any>, CategoryId?, option?) {

     this.catId = CategoryId ;
    if(option){
      this.temp= option ; 
    }
     this.temp.CategoryId = CategoryId

    this.modalRef = this.modalService.show(template);

    if (CategoryId) {
      this.form.get('parentId').setValue(CategoryId);
    }
    // this.focus()
  }
  // focus() {
  //   const element = this.renderer.selectRootElement('.inputFocus');
  //   element.focus();
  // }


  checkCode(event) {

    let code = event.target.value.toUpperCase()
    let found = false
    for (let i = 0; i < this.levels.length; i++) {
      const lvl = this.levels[i];
      for (let ii = 0; ii < lvl.optionsList.length; ii++) {
        const lvlOptn = lvl.optionsList[ii];
        if (lvlOptn.code.toUpperCase() === code) {
          found = true
        }
      }

      if (lvl.subLevelList != null && lvl.subLevelList.length > 0) {
        for (let iii = 0; iii < lvl.subLevelList.length; iii++) {
          const lvlSublvl = lvl.subLevelList[iii];
          for (let iiii = 0; iiii < lvlSublvl.length; iiii++) {
            const lvlSubOtnLSt = lvlSublvl[iiii];

            if (lvlSubOtnLSt.code.toUpperCase() === code) {
              found = true
            }
          }
        }
      }
    }
    if (found == true) {
      this.temp.codeError = 'this code is used, please change it'
    }
    else {
      this.temp.codeError = ''
    }
  }



  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2500,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  filterOptions() {
    this.filterdOptions = JSON.parse(JSON.stringify(this.levels))
    if (this.filterText != "") {

      for (let i = 0; i < this.filterdOptions.length; i++) {
        const lvl = this.filterdOptions[i];
        for (let index = 0; index < lvl.optionsList.length; index++) {
          const opt = lvl.optionsList[index];

          if (opt.code.toUpperCase().indexOf(this.filterText.toUpperCase()) == -1 &&
            opt.name.toUpperCase().indexOf(this.filterText.toUpperCase()) == -1) {

            lvl.optionsList.splice(index, 1)
            index--


          }


        }

      }


      // this.levels.forEach(lvl => {
      //   lvl.optionsList.forEach(element => {

      //     if (element.code.toUpperCase().indexOf(this.filterText.toUpperCase()) >= 0 || element.name.toUpperCase().indexOf(this.filterText.toUpperCase()) >= 0) {


      //       this.filterdOptions.splice(0, 2, lvl)



      //     }

      //   });

      // });

    }


  }

  saveNewLevel(): void {




    this._CategoryDetails.controls.forEach((group: FormArray) => {
      group.get('slug').setValue(group.get('name').value)
    })



    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(felid => {
        this.form.controls[felid].markAsTouched();
      });
      return
    }

    var data = this.form.value;

    this.httpClient.post('/CategoriesApi/AddCategory', data).subscribe((res: any) => {
      this.openNotifySuccess('level saved')
      this.modalRef.hide();
      this.resetForm();
      // this.getUserCutler();
      this.getAllLevels();
    });


  }

  saveNewSubLevel(): void {




    this._CategoryDetails.controls.forEach((group: FormArray) => {
      group.get('slug').setValue(group.get('name').value)
    })


    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(feild => {
        this.form.controls[feild].markAsTouched();
      });
      return
    }

    // var data = {
    //   Name: this.temp.newSubLevel,
    //   Slug: this.temp.newSubLevel,
    //   ParentId: this.temp.CategoryId ? this.temp.CategoryId : this.catId,
    //   CategoryTypeId: 6,
    //   Status: 1
    // }


    var data = this.form.value;

    this.httpClient.post('/CategoriesApi/AddCategory', data).subscribe((res: any) => {
      this.openNotifySuccess('Sub level saved')
      this.modalRef.hide();
      this.resetForm();
      // this.getUserCutler();
      this.getAllLevels();

    });

  }

  saveLevelOption(form): void {

    if (form.invalid) {
      Object.keys(form.controls).forEach(feild => {
        form.controls[feild].markAsTouched(true);
      });
      return
    }

    var data = {
      lstOptions: [{
        id: this.temp.id ? this.temp.id : 0,
        Name: this.temp.name,
        Code: this.temp.code,
        CategoryId: this.catId
      }]
    }


    if (this.temp.id) {
      this.httpClient.post('/RolesManagement/EditOption', data).subscribe((res: any) => {
        this.openNotifySuccess('Option Modified')
        this.modalRef.hide();
        this.getAllLevels();
        this.temp = {};
      });
    } else
      this.httpClient.post('/RolesManagement/AddLevelOption', data).subscribe((res: any) => {
        this.openNotifySuccess('Option saved')
        this.modalRef.hide();
        this.getAllLevels();
        this.temp = {};
      });
  }

  loadScript() {
    const head = document.getElementsByTagName('body')[0];
    const script = document.createElement('script');
    script.src = "./assets/js/pages/crud/forms/widgets/bootstrap-switch.js"
    script.type = 'text/javascript';
    var oldJs = document.getElementsByTagName('script');
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      if (element.src.indexOf('bootstrap-switch.js') != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    head.appendChild(script);
  }



  get _CategoryDetails() {
    return this.form.get("CategoryDetails") as FormArray
  }



}
